import { render, staticRenderFns } from "./EditInformations.vue?vue&type=template&id=2c09859a&scoped=true&"
import script from "./EditInformations.vue?vue&type=script&lang=js&"
export * from "./EditInformations.vue?vue&type=script&lang=js&"
import style0 from "./EditInformations.vue?vue&type=style&index=0&id=2c09859a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c09859a",
  null
  
)

export default component.exports